import { ObjectSchema, object, string, boolean, number, date } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { OpsUser } from '../../models/ops-user';
yup.setLocale(locale);

export function opsUserValidator(): ObjectSchema<OpsUser> {
    return object({
        id: string().uuid().strict(),
        name: string().required().nonNullable().strict().max(32),
        password: string()
            .required()
            .min(8)
            .matches(/[A-Za-z]/, 'account-settings.password.error.letter-required')
            .matches(/\d/, 'account-settings.password.error.number-required')
            .matches(/[!"#$%&'()]/, 'account-settings.password.error.special-char-required'),
        permissions: yup.array().strict(),
        isAdmin: boolean().strict().default(false),
        index: number().notRequired(),
        sessionTimeout: number().nullable(),
        createdAt: date().notRequired(),
        updatedAt: date().notRequired(),
    })
        .strict()
        .noUnknown();
}
